export default __webpack_public_path__ + "static/media/dots.22cf269c.svg";